import React from "react";

import { Container } from "react-bootstrap";

const Success = () => {
  return (
    <div className="mt-5">
      <Container>
        <h2>Success</h2>
      </Container>
    </div>
  );
};

export default Success;
